module.exports = __webpack_public_path__ + "img/sincechild-title.448a391b.png";